/** @format */

import {PointName} from 'components/charts/multiline-chart/model/common';

export interface FilteredXAxis {
  name: PointName;
  month: string;
}

interface MonthMarkerPropsWithTick extends MonthMarkerProps {
  x: number;
  payload: {
    value: PointName;
  };
}

interface MonthMarkerProps {
  data: FilteredXAxis[];
}

const MonthMarker = (props: MonthMarkerPropsWithTick) => {
  const {data, x, payload} = props;
  const pointName = payload.value;
  const month = data.find(k => k.name === pointName)?.month;

  if (!month) return null;

  return (
    <text key={pointName} x={x - 4} y={10} fill={'#FAFBFE'} fontSize={14}>
      {month}
    </text>
  );
};

export {MonthMarker};
